import { appStore } from '@/store';
import { logger, redirectToGenericError } from '@/lib';
// @ts-expect-error
import { fetchCheckoutSessionData } from '@/components/App/api';
import type { CheckoutSessionDataQueryQuery } from '@/generated/graphql';

/**
 * @function refetchCheckoutSession
 * @description Refetches the checkout session to sync the cart after
 * XOBNS resets shipping/tax server-side
 */
const refetchCheckoutSession = (): Promise<void> =>
  fetchCheckoutSessionData({ fetchPolicy: 'network-only' })
    .then(({ data }: { data: CheckoutSessionDataQueryQuery }) => {
      const { amounts, shippingMethods } = data.checkoutSession?.cart || {};
      const { api: apiState } = appStore.getState();
      const { cartDetails } = apiState;
      const { api: apiActions } = appStore.getActions();

      apiActions.setCartData({
        cartAmount: amounts?.total,
        cartDetails: {
          ...cartDetails,
          amounts: amounts || {},
        },
        shippingMethods: shippingMethods || [],
      });
    })
    .catch((error: unknown) => {
      logger.error('refetch_checkout_session_error', { error });
      redirectToGenericError();
    });

export { refetchCheckoutSession };
